import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map_white_scene_manager",
  "use": "icon-map_white_scene_manager-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-map_white_scene_manager\"><path d=\"M512 128L128 352l384 224 384-224-384-224zM128 480l384 224 384-224M128 608l384 224 384-224\" fill=\"none\" stroke=\"#2b8eec\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/map/map_white_scene_manager.svg
// module id = LWz/
// module chunks = 24